import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { createSelector, StoreModule } from "@ngrx/store";
import { PlansEffect } from "./effect";
import { PlansReducer } from "./reducer";

@NgModule({
  imports: [EffectsModule.forFeature([PlansEffect]), StoreModule.forFeature("plans", PlansReducer)]
})
export class PlansStoreModule {}

export const plansList = (store: any) => store && store.plans && store.plans.plansList;
export const modulesAndFeaturesList = (store: any) => store && store.plans && store.plans.modulesAndFeaturesList;
export const planById = (store: any) => store && store.plans && store.plans.planById;
export const planTemplateById = (store: any) => store && store.plans && store.plans.planTemplateById;
export const addPlansResponse = (store: any) => store && store.plans && store.plans.addPlansResponse;
export const updatePlansResponse = (store: any) => store && store.plans && store.plans.updatePlansResponse;
export const deletePlansResponse = (store: any) => store && store.plans && store.plans.deletePlansResponse;

export const planByIdWithAllFeaturesAndPermissions = createSelector(planById, modulesAndFeaturesList, (planData, modulesAndFeatures) => {
  if (planData && modulesAndFeatures?.length) {
    return {
      planById: planData,
      modulesAndFeaturesList: modulesAndFeatures
    };
  }
});
